import R from 'ramda'
import { maxPrice, maxRooms, maxYield } from './Constants'

export const SortTypes = {
  ASC: -1,
  DESC: 1
}

export const slugify = text => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export const unslugify = text => {
  return text
    .toString()
    .replace(/\b\w/g, l => l.toUpperCase()) // Capitalize
    .replace('-', ' ') // Replace - with spaces
}

export const numberWithCommas = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const addOrRemoveObjectFromList = (list, object, prop = 'id') => {
  let index = R.findIndex(R.propEq(prop, object[prop]))(list)
  if (index >= 0) {
    return R.remove(index, 1, list)
  }
  return R.append(object, list)
}

export const isElementInArray = (list, object, prop = 'id') => {
  return R.findIndex(R.propEq(prop, object.id))(list) !== -1
}

export const sortArray = (keyObj, elements) => {
  const list = R.clone(elements)
  const sortKey = R.clone(keyObj)

  if (elements.length === 0) {
    return
  }

  const direction =
    sortKey.sort === (SortTypes.DESC || null) ? SortTypes.ASC : SortTypes.DESC

  list.sort((elementA, elementB) => {
    let valueA = sortKey.sortAccessor
      ? sortKey.sortAccessor(elementA)
      : sortKey.accessor ? sortKey.accessor(elementA) : elementA[sortKey.key]

    let valueB = sortKey.sortAccessor
      ? sortKey.sortAccessor(elementB)
      : sortKey.accessor ? sortKey.accessor(elementB) : elementB[sortKey.key]

    let sortVal = 0

    if (valueA.toLowerCase) {
      valueA = valueA.toLowerCase()
    }

    if (valueB.toLowerCase) {
      valueB = valueB.toLowerCase()
    }

    if (valueA > valueB) {
      sortVal = 1
    }
    if (valueA < valueB) {
      sortVal = -1
    }
    sortVal *= direction
    return sortVal
  })

  sortKey.sort = direction

  return {
    list,
    sortKey
  }
}

export const isErrorOfInvalidAttribute = (
  errorResponse = {},
  attribute,
  rule
) => {
  return (
    errorResponse.data &&
    errorResponse.data.invalidAttributes &&
    errorResponse.data.invalidAttributes[attribute] &&
    errorResponse.data.invalidAttributes[attribute].rule === rule
  )
}

export const isUserFavorite = (user, property) => {
  let pred = d => d.id === property.id
  return R.filter(pred, user.preferredProperties).length > 0
}

export const isElementSelected = (el, list) => {
  return R.findIndex(R.propEq('id', el.id))(list) !== -1
}

export const customizeSearchCriteria = criteria => {
  let query = R.clone(criteria)

  query.preferredCategories = query.preferredCategories
    ? query.preferredCategories.map(category => category.id)
    : []
  query.preferredCities = query.preferredCities
    ? query.preferredCities.map(city => city.id)
    : []
  query.preferredCountries = query.preferredCountries
    ? query.preferredCountries.map(country => country.id)
    : []
  query.preferredRegions = query.preferredRegions
    ? query.preferredRegions.map(region => region.id)
    : []

  if (query.maxInvestment === maxPrice) {
    delete query.maxInvestment
  }

  if (query.maxNoRooms === maxRooms) {
    delete query.maxNoRooms
  }

  if (query.maxYield === maxYield) {
    delete query.maxYield
  }

  return query
}



// WEBPACK FOOTER //
// ./src/Utils/index.js